module.exports = __webpack_public_path__ + "img/img_flag_io.4f1a4f6f.png";